import * as React from 'react';
import styled from 'styled-components';

import {
  useContractContext,
  useModalSettingsContext,
  useStrings,
  useTheme,
} from 'src/providers';

import { PrimaryButton } from '../Button/PrimaryButton';

export const StyledAddAndDeclineProtection = styled.div<{ fullWidth: boolean }>`
  margin-top: ${({ fullWidth }) => fullWidth ? '16px' : '32px'};
  text-align: center;

  .add-button {
    ${({ fullWidth }) => !fullWidth && 'min-width: 270px;'}
    ${({ fullWidth }) => fullWidth && 'width: 100%;'}
    max-width: 100%;
    white-space: nowrap;
    display: inline-block;
    font-size: ${({ fullWidth }) => fullWidth ? 16 : 20}px;
    font-family: inherit;
    font-weight: 600;
    line-height: 2.75em;
    text-decoration: none;
    border-radius: 0.5em;
    padding: 0 1em;
    cursor: pointer;

    &:hover {
      box-shadow: 0px 4px 11px rgba(0, 0, 0, 0.11);
    }
  }

  .decline-button {
    background-color: transparent;
    color: #000000;
    font-family: inherit;
    text-align: center;
    line-height: inherit;
    text-decoration: none;
    margin-top: 16px;
    cursor: pointer;
    
    &.big {
      width: 100%;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      font-size: 16px;
      font-weight: 400;
      line-height: 2.75em;
      margin-top: 0.5em;
      border: 1px solid var(--light-gray);
      border-radius: 0.5em;

      &:focus, &:hover {
        border-color: #000000;
      }
    }
    
    &.small {
      display: inline-block;
      font-size: 13px;
      font-weight: 400;

      &:focus, &:hover {
        text-decoration: underline;
      }

      @media (min-width: 551px) {
        font-size: 16px;
      }
    }
  }
`;

// 2023/02/06 AJC why are the buttons below both wrapped in <div>s? I'm currently working on an
// experiment so I feel like it's not the time to change that, but we probably should eventually.

const AddAndDeclineProtection = () => {
  const { addProtection, declineProtection } = useContractContext();
  const { modalType } = useModalSettingsContext();
  const { addProtectionButtonLabel, declineButtonLabel } = useStrings();
  const { fullWidthAddAndDeclineProtection } = useTheme();

  return (
    <StyledAddAndDeclineProtection fullWidth={fullWidthAddAndDeclineProtection}>
      <div>
        <PrimaryButton
          data-test='add-button'
          className='add-button'
          data-testid='add-button'
          onClick={() => { addProtection(modalType); }}>
          {addProtectionButtonLabel}
        </PrimaryButton>
      </div>

      <div>
        <button
          data-test='decline-button'
          className={`button-reset decline-button ${fullWidthAddAndDeclineProtection ? 'big' : 'small'}`}
          onClick={() => { declineProtection('decline-button', modalType); }}>
          {declineButtonLabel}
        </button>
      </div>
    </StyledAddAndDeclineProtection>
  );
};

export default AddAndDeclineProtection;
